import React from 'react';
import { articles } from '../data/mock';
import { ArrowRight, Clock } from 'lucide-react';

const LearnMore = () => {
  return (
    <section className="py-24 bg-[#0b0014]">
      <div className="max-w-[1400px] mx-auto px-6">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-12">
          Learn more
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((article, index) => (
            <a 
              key={index}
              href={article.link}
              className="group p-6 bg-white/[0.02] hover:bg-white/[0.04] border border-white/[0.06] hover:border-purple-500/30 rounded-xl transition-all duration-300"
            >
              <div className="flex items-start justify-between mb-4">
                <h3 className="text-lg font-semibold text-white group-hover:text-purple-300 transition-colors pr-4">
                  {article.title}
                </h3>
                <ArrowRight className="w-5 h-5 text-gray-500 group-hover:text-purple-400 group-hover:translate-x-1 transition-all flex-shrink-0" />
              </div>
              <div className="flex items-center gap-2 text-gray-500">
                <Clock className="w-4 h-4" />
                <span className="text-sm">{article.duration}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LearnMore;
